import { appConfig } from '@appConfig';
import { computed, watch } from 'vue';
import { useTheme } from 'vuetify';
import i18n from '@/plugins/i18n';

export const useThemeConfig = () => {
  const key = appConfig.key || 'root';

  const theme = computed({
    get() {
      const storedTheme = appConfig.theme.value;
      return storedTheme ? storedTheme : theme.global?.current?.value?.dark ? 'dark' : 'light';
    },
    set(value) {
      appConfig.theme.value = value;
      localStorage.setItem(`${key}-theme`, value);
    },
  });

  const locale = computed({
    get() {
      return appConfig.locale.value;
    },
    set(value) {
      localStorage.setItem(`${key}-locale`, value.toString());
      appConfig.locale.value = value;
      i18n.global.locale.value = value;
      isAppRtl.value = TenantConfig?.locales.find(locale => locale.code == value && locale.is_rtl) ? true : false;
    },
  });

  const syncVuetifyThemeWithTheme = () => {
    const vuetifyTheme = useTheme();
    vuetifyTheme.themes.value.light.colors.primary = TenantConfig?.app_color || '#166170';
    vuetifyTheme.themes.value.dark.colors.primary = TenantConfig?.app_color || '#166170';
    watch(appConfig.theme, value => {
      vuetifyTheme.change(value);
      localStorage.setItem(`${key}-initial-loader-bg`, vuetifyTheme.themes.value[value].colors.surface);
      localStorage.setItem(`${key}-initial-loader-color`, vuetifyTheme.themes.value[value].colors.primary);
    });
  };

  const _setAppDir = dir => {
    document.documentElement.setAttribute('dir', dir);
  };

  const isAppRtl = computed({
    get() {
      return appConfig.isRtl.value;
    },
    set(value) {
      localStorage.setItem(`${key}-isRtl`, value.toString());
      appConfig.isRtl.value = value;
      _setAppDir(value ? 'rtl' : 'ltr');
    },
  });

  return {
    theme,
    locale,
    isAppRtl,
    syncVuetifyThemeWithTheme,
    _setAppDir,
  };
};
